import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCurrencyRupees: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="currency-rupees, money"><path d="M4.75 2.75H19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/><path d="M4.75 8H19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/><path d="M16 21.75L4.75 13.66V13.25H11C18 13.25 18 2.75 11 2.75" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconCurrencyRupees;
